import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import FeaturedProducts from './components/FeaturedProducts';
import CategoriesGrid from './components/CategoriesGrid';
import SEOArticlesSection from './components/SEOArticlesSection';
import ComparisonSection from './components/ComparisonSection';
import SecuritySection from './components/SecuritySection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <article>
        <HeroSection />
        <TrustBadges />
        <CategoriesGrid />
        <FeaturedProducts />
        <SEOArticlesSection />
        <ComparisonSection />
        <SecuritySection />
        <FAQSection />
        <CTASection />
      </article>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Maior Hoobuy Spreadsheet em Português',
            description: 'Encontre o maior Hoobuy Spreadsheet em português com mais de 20.000 produtos, links atualizados diariamente e fornecedores verificados para Brasil e Portugal.',
            url: 'https://hoobuy.homes/',
            inLanguage: 'pt-BR',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Hoobuy Homes',
              url: 'https://hoobuy.homes',
            },
            about: {
              '@type': 'Thing',
              name: 'Hoobuy Spreadsheet',
              description: 'Planilha organizada com mais de 20.000 produtos, links verificados e atualizados diariamente.',
            },
            primaryImageOfPage: {
              '@type': 'ImageObject',
              url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg',
            },
          }),
        }}
      />
    </main>
  );
}